import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import TableHead from "@material-ui/core/TableHead";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import { BACKEND_DATE_FORMAT } from "../components/Constants";
import DatePicker from "react-datepicker";
import BigInteger from "big-integer";
import PopupMessage from "../components/PopupMessage";

import UploadIssuesIcon from "@material-ui/icons/OpenInBrowserOutlined";
import AddNewItemIcon from "@material-ui/icons/AddToPhotosOutlined";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class UploadItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      minutesLeft: "-1",
      canDo: false,
      items: [],
      payeeRequired: false,
      redraw: false,
    };
    this.onClose = this.onClose.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }
  componentDidUpdate() {
    if (this.state.redraw) {
      this.setState({ redraw: false });
    }
  }
  componentDidMount() {
    fetch("on_upload_item", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        range_start: this.props.accountObject.rangeStart,
        range_end: this.props.accountObject.rangeEnd,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          }
          this.setState({ minutesLeft: reply.minutesLeft });
          if (reply.minutesLeft !== "0" && reply.minutesLeft !== "-1")
            this.setState({ canDo: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
    let myAccountType = this.props.accountObject.accountType;
    if (myAccountType.indexOf("PPP") !== -1) {
      this.setState({ payeeRequired: true });
    }
    this.handleAdd(null);
  }
  onClose(e) {
    e.preventDefault();
    this.props.onCloseUpload(e);
  }

  handleUpload(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      return;
    }
    if (this.validate()) {
      this.setState({ canDo: false });         
      let myItems = this.state.items;
      let myUploadItems = new Array(myItems.length);
      let i;
      for (i = 0; i < myItems.length; i++) {
        let myItem = myItems[i];
        let item = {
          itemNum: myItem.itemNum,
          checkNumber: myItem.checkNumber,
          date: myItem.backendCheckDate,
          amount: myItem.amount,
          payee: myItem.payee,
        };
        myUploadItems[i] = item;
      }

      fetch("on_upload_items_request", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.accountObject.transit,
          account: this.props.accountObject.account,
          type: this.props.accountObject.accountType,
          rangeStart: this.props.accountObject.rangeStart,
          rangeEnd: this.props.accountObject.rangeEnd,
          items: myUploadItems,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
          } else {
            if (reply.warning) {
              this.setState({ notifyString: reply.warningString });
            } else {
              this.setState({ notifyString: "Your items have been uploaded." });
            }
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });       
    }
  }

  handleDate(date, index) {
    let myItems = this.state.items;
    myItems[index].checkDate = date;
    if (date === null) {
      myItems[index].backendCheckDate = "";
    } else {
      myItems[index].backendCheckDate = date.format(BACKEND_DATE_FORMAT);
    }
    this.setState({ items: myItems });
  }

  handleDateOutsideClick(e, index) {
    this.setState({ redraw: true });
  }

  handleAmount(e, index) {
    let myItems = this.state.items;
    myItems[index].amount = e.target.value;
    this.setState({ items: myItems });
  }

  handleCheckNumber(e, index) {
    let myItems = this.state.items;
    myItems[index].checkNumber = e.target.value;
    this.setState({ items: myItems });
  }

  handlePayee(e, index) {
    let myItems = this.state.items;
    myItems[index].payee = e.target.value;
    this.setState({ items: myItems });
  }

  handleDelete(e, index) {
    let myItems = this.state.items;
    myItems.splice(index, 1);
    this.updateIndexes(myItems);
  }

  handleAdd(e) {
    if (this.validate()) {
      let myItems = this.state.items;
      let item = {
        index: 0,
        itemNum: 0,
        checkNumber: "",
        checkDate: null,
        backendCheckDate: "",
        amount: "",
        payee: "",
      };
      if (myItems.length > 0) {
        let firstItem = myItems[0];
        item.checkDate = firstItem.checkDate;
        item.backendCheckDate = firstItem.backendCheckDate;
        let checkNum = "" + BigInteger(firstItem.checkNumber).add(1);
        item.checkNumber = checkNum;
      }
      myItems.unshift(item);
      this.updateIndexes(myItems);
      fetch("on_keep_alive", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          r: new Date().getTime(),
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          let reply = JSON.parse(text);
          if (reply.authenticated === false) {
            this.props.history.push("/expired");
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
    }
  }

  updateIndexes(myItems) {
    let i;
    for (i = 0; i < myItems.length; i++) {
      myItems[i].index = i;
      myItems[i].itemNum = myItems.length - i;
    }
    this.setState({ items: myItems });
    this.setState({ redraw: true });
  }

  validate() {
    let myItems = this.state.items;
    let i;
    let error = "";
    let startRange = BigInteger(this.props.accountObject.rangeStart);
    let endRange = BigInteger(this.props.accountObject.rangeEnd);
    for (i = 0; i < myItems.length; i++) {
      let myItem = myItems[i];
      if (myItem.checkNumber.length === 0) {
        error =
          "Item " +
          myItem.itemNum +
          " : " +
          getErrorString(
            "stopPayment.checkNumber.error",
            "Check Number is required."
          );
        break;
      }
      if (myItem.amount.length === 0) {
        error =
          "Item " +
          myItem.itemNum +
          " : " +
          getErrorString("stopPayment.amount.error", "Amount is required.");
        break;
      }
      if (myItem.backendCheckDate.length === 0) {
        error =
          "Item " +
          myItem.itemNum +
          " : " +
          getErrorString(
            "stopPayment.checkDate.error",
            "Check Date is required."
          );
        break;
      }
      if (this.state.payeeRequired && myItem.payee.length === 0) {
        error =
          "Item " +
          myItem.itemNum +
          " : " +
          getErrorString("disposition.payee.error", "Payee is required.");
        break;
      }
      let checkNum = BigInteger(myItem.checkNumber);
      if (checkNum.lesser(startRange) || checkNum.greater(endRange)) {
        error =
          "Item " +
          myItem.itemNum +
          " : " +
          getErrorString(
            "upload.checkNumber.outofrange.error",
            "Check Number is out of range."
          );
        break;
      }
    }
    if (error.length > 0) {
      this.setState({ errorString: error });
      return false;
    }
    return true;
  }
  render() {
    const { classes } = this.props;
    let data = this.state.items;
    let { t } = this.props;
    const datePickerTopMargin = 8;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error:")}
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClose}
          />
        )}

        <Paper elevation={5}>
          <Typography variant="body1" color="error">
            {this.state.minutesLeft === 0
              ? t("uploadNoTime.label")
              : this.state.minutesLeft === -1
              ? t("uploadNotAvai.label")
              : t("youHave.label") +
                "     " +
                this.state.minutesLeft +
                t("uploadMinLeft.label")}
          </Typography>
          <FormGroup row>
            <Typography variant="h6" color="primary">
              &nbsp;&nbsp; {t("uploadInd.tip")}
              &nbsp;&nbsp;
            </Typography>
            <Tooltip title={t("uploadNewItem.tip")}>
              <Button
                onClick={(event) => this.handleUpload(event)}
                color="primary"
                disabled={!this.state.canDo}
              >
                <UploadIssuesIcon />
                &nbsp;{t("upload.label")}
              </Button>
            </Tooltip>
          </FormGroup>

          <Divider />
          <FormGroup row>
            <Button
              onClick={(event) => this.handleAdd(event)}
              color="primary"
              disabled={!this.state.canDo}
            >
              <AddNewItemIcon />
              &nbsp;{t("addNewItem.button")}
            </Button>
          </FormGroup>
          {!this.state.redraw && (
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "8%" }}>
                    {t("item.header")}
                  </TableCell>
                  <TableCell style={{ width: "8%" }}>
                    {t("cheqNumReq.header")}
                  </TableCell>
                  <TableCell style={{ width: "8%" }}>
                    {t("amountReq.header")}
                  </TableCell>
                  <TableCell style={{ width: "8%" }}>
                    {t("checkDateReq.header")}
                  </TableCell>
                  <TableCell style={{ width: "60%" }}>
                    {this.state.payeeRequired
                      ? t("payeeReq.header")
                      : t("payee.header")}
                  </TableCell>
                  <TableCell style={{ width: "8%" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((n) => {
                  return (
                    <TableRow key={n.index}>
                      <TableCell>{n.itemNum}</TableCell>
                      <TableCell>
                        <TextField
                          margin="dense"
                          id={"checkNumber_" + n.index}
                          type="text"
                          defaultValue={n.checkNumber}
                          onChange={(event) =>
                            this.handleCheckNumber(event, n.index)
                          }
                          onKeyPress={(event) => {
                            return event.charCode >= 48 && event.charCode <= 57
                              ? true
                              : event.preventDefault();
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          margin="dense"
                          id={"amount_" + n.index}
                          type="text"
                          defaultValue={n.amount}
                          onChange={(event) =>
                            this.handleAmount(event, n.index)
                          }
                          InputProps={{
                            inputComponent: AmountFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell style={{ marginTop: datePickerTopMargin }}>
                        <DatePicker
                          isClearable
                          disabledKeyboardNavigation
                          dateFormat="LL"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          fixedHeight
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                            },
                          }}
                          selected={this.state.items[n.index].checkDate}
                          onChange={(event) => this.handleDate(event, n.index)}
                          onClickOutside={(event) =>
                            this.handleDateOutsideClick(event, n.index)
                          }
                          popperContainer={CalendarContainer}
                        />
                      </TableCell>
                      <TableCell style={{ width: "60%" }}>
                        <TextField
                          margin="dense"
                          id={"payee_" + n.index}
                          type="text"
                          multiline={true}
                          rows={2}
                          style={{ width: "100%", wordWrap: "break-word" }}
                          defaultValue={n.payee}
                          onChange={(event) => this.handlePayee(event, n.index)}
                        />
                      </TableCell>
                      {n.index === 0 && <TableCell></TableCell>}
                      {n.index > 0 && (
                        <TableCell>
                          <Button
                            onClick={(event) =>
                              this.handleDelete(event, n.index)
                            }
                            color="primary"
                          >
                            {t("delete.button")}
                          </Button>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </Paper>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(UploadItems));
